import React, { useEffect, useRef, useState } from 'react';
import ere from 'element-resize-event';

export default function AutoScale(props) {

    const { children, wrapperClass, containerClass, contentClass, maxHeight, maxWidth, maxScale } = props;
    const wrapper = useRef();
    const container = useRef();
    const content = useRef();

    const [wrapperSize, setWrapperSize] = useState({ width: 0, height: 0 })
    const [contentSize, setContentSize] = useState({ width: 0, height: 0 })
    const [scale, setScale] = useState(1);
    const [containerHeight, setContainerHeight] = useState(0);
    const [containerWidth, setContainerWidth] = useState(0);

    useEffect(() => {
        const actualContent = content.current.children[0];

        setWrapperSize({ width: wrapper.current.offsetWidth, height: wrapper.current.offsetHeight });
        setContentSize({ width: actualContent.offsetWidth, height: actualContent.offsetHeight })


        ere(actualContent, () => {
            setContentSize({ width: actualContent.offsetWidth, height: actualContent.offsetHeight })

        });

        ere(wrapper.current, () => {
            setWrapperSize({ width: wrapper.current.offsetWidth, height: wrapper.current.offsetHeight });
        });
    }, [])

    useEffect(() => {
        let newScale = (wrapperSize.width / contentSize.width);

        if (maxHeight) {
            newScale = Math.min(newScale, (maxHeight / contentSize.height));
        }
        if (maxWidth) {
            newScale = Math.min(newScale, (maxWidth / contentSize.width));
        }
        if (maxScale) {
            newScale = Math.min(newScale, maxScale);
        }
        setScale(newScale)
        setContainerHeight((newScale * contentSize.height))
        setContainerWidth((newScale * contentSize.width))
    }, [contentSize, maxHeight, maxScale, maxWidth, wrapperSize])

    return (
        <div ref={wrapper} className={wrapperClass}>
            <div ref={container} className={containerClass} style={{ maxWidth: '100%', overflow: 'hidden', width: containerWidth + 'px', height: containerHeight + 'px' }}>
                <div ref={content} className={contentClass} style={{ transform: 'scale(' + scale + ')', transformOrigin: '0 0 0' }}>
                    {React.Children.only(children)}
                </div>
            </div>
        </div>
    );

}